var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpdate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48.648,
    height: 54.729,
    viewBox: "0 0 48.648 54.729",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x2: 1,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#af0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d0021b"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_3705"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161,
    result: "color"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4423",
    "data-name": "Group 4423",
    transform: "translate(-160 -256)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3635",
    "data-name": "Group 3635",
    transform: "translate(160 256)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3705-2",
    "data-name": "Path 3705",
    d: "M0,17.162,24.324,5,48.648,17.162V47.567L24.324,59.729,0,47.567Z",
    transform: "translate(0 -5)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    filter: "url(#Path_3705)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3705-3",
    "data-name": "Path 3705",
    d: "M0,17.162,24.324,5,48.648,17.162V47.567L24.324,59.729,0,47.567Z",
    transform: "translate(0 -5)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-system-update",
    "data-name": "Icon material-system-update",
    d: "M22.095,1.512,9.932,1.5A2.44,2.44,0,0,0,7.5,3.932V25.824a2.44,2.44,0,0,0,2.432,2.432H22.095a2.44,2.44,0,0,0,2.432-2.432V3.932A2.429,2.429,0,0,0,22.095,1.512Zm0,21.88H9.932V6.365H22.095Zm-1.216-7.3H17.23V10.013H14.8v6.081H11.149l4.865,4.865Z",
    transform: "translate(168.311 269.095)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdate);
export default __webpack_public_path__ + "static/media/Update.4a7dca17c9aed1b9b57e31a49d580c80.svg";
export { ForwardRef as ReactComponent };